import React, { useEffect, useState } from 'react';
import { SearchIcon, XIcon } from 'lucide-react';
export function SiteLookupModal({
  isOpen,
  onClose,
  onSelectSite,
  sites,
  selectedEntityId
}) {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSite, setSelectedSite] = useState(null);
  const [filteredSites, setFilteredSites] = useState([]);
  // Filter sites based on selected entity and search term
  useEffect(() => {
    let sitesToShow = sites;
    // Filter by entity if one is selected
    if (selectedEntityId) {
      sitesToShow = sites.filter(site => site.entityId === selectedEntityId);
    }
    // Then filter by search term
    if (searchTerm) {
      sitesToShow = sitesToShow.filter(site => site.name.toLowerCase().includes(searchTerm.toLowerCase()) || site.code.toLowerCase().includes(searchTerm.toLowerCase()) || site.address.toLowerCase().includes(searchTerm.toLowerCase()));
    }
    setFilteredSites(sitesToShow);
  }, [searchTerm, sites, selectedEntityId]);
  // Handle site selection
  const handleSelectSite = site => {
    setSelectedSite(site);
  };
  // Handle confirm selection
  const handleConfirmSelection = () => {
    if (selectedSite) {
      onSelectSite(selectedSite);
    }
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex items-center justify-center z-50" data-id="element-17572">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[80vh] flex flex-col" data-id="element-17573">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200" data-id="element-17574">
          <h3 className="text-lg font-medium text-gray-900" data-id="element-17575">Site Lookup</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500 focus:outline-none" data-id="element-17576">
            <XIcon className="h-5 w-5" data-id="element-17577" />
          </button>
        </div>
        {/* Search Bar */}
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-17578">
          <div className="relative rounded-md shadow-sm" data-id="element-17579">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-17580">
              <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-17581" />
            </div>
            <input type="text" className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md" placeholder="Search by site name, code, or address" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-17582" />
          </div>
          {selectedEntityId && <div className="mt-2 text-sm text-gray-500" data-id="element-17583">
              Showing sites for entity:{' '}
              {sites.find(site => site.entityId === selectedEntityId)?.entityName || selectedEntityId}
            </div>}
        </div>
        {/* Site List */}
        <div className="flex-1 overflow-auto" data-id="element-17584">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-17585">
            <thead className="bg-gray-50" data-id="element-17586">
              <tr data-id="element-17587">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17588">
                  Site Code
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17589">
                  Name
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17590">
                  Entity
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17591">
                  Address
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17592">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-17593">
              {filteredSites.length > 0 ? filteredSites.map(site => <tr key={site.id} onClick={() => handleSelectSite(site)} className={`cursor-pointer hover:bg-gray-50 ${selectedSite?.id === site.id ? 'bg-indigo-50' : ''}`} data-id="element-17594">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-17595">
                      {site.code}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-17596">
                      {site.name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-17597">
                      {site.entityName}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-17598">
                      {site.address}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-17599">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${site.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-17600">
                        {site.status}
                      </span>
                    </td>
                  </tr>) : <tr data-id="element-17601">
                  <td colSpan={5} className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-17602">
                    {selectedEntityId ? 'No sites found for this entity matching your search criteria' : 'No sites found matching your search criteria'}
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-200 flex justify-end" data-id="element-17603">
          <button type="button" className="mr-3 px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={onClose} data-id="element-17604">
            Cancel
          </button>
          <button type="button" className="px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={handleConfirmSelection} disabled={!selectedSite} data-id="element-17605">
            Select Site
          </button>
        </div>
      </div>
    </div>;
}